import { Currency, formatCurrencyFull } from '../../../../utilities/currency'
import { Space, TextInput, Typography } from '../../atoms'
import { Attribute } from '../../molecules'

export type TradeTopupProps = {
  change: number
  currency: Currency
  current: number
  minChange: number
  onChange: (updatedAmount: number) => void
  topupOrWithdrawal: 'topup' | 'withdraw'
  total: number
}

export function TradeTopup({
  change,
  currency,
  current,
  minChange,
  onChange,
  topupOrWithdrawal,
  total
}: TradeTopupProps) {
  const heading = topupOrWithdrawal === 'topup' ? 'Top up' : 'Withdraw'
  const changeAmountDescription =
    topupOrWithdrawal === 'topup'
      ? `Top up amount (min ${minChange} Rand)`
      : `Withdrawal amount (min ${minChange} Rand)`
  const renderAttributeName = (name: string) => <Typography variant="b3">{name}</Typography>
  const onAmountChange = (updatedValue: string) => {
    let updatedNumberValue = parseFloat(updatedValue)
    if (updatedNumberValue < 0) {
      updatedNumberValue *= -1
    }
    onChange(updatedNumberValue)
  }
  return (
    <Space mx={5} py={6}>
      <Space mb={5}>
        <Typography fontSize="13px" fontWeight="400" variant="sh3">
          {heading}
        </Typography>
      </Space>
      <Attribute nameComponent={renderAttributeName('Current balance (Rand)')}>
        <Typography variant="sh3">{formatCurrencyFull(current, currency)}</Typography>
      </Attribute>
      <Attribute nameComponent={renderAttributeName(changeAmountDescription)}>
        <Typography variant="sh3">
          <TextInput
            type="number"
            value={change}
            onChange={event => onAmountChange(event.target.value)}
          />
        </Typography>
      </Attribute>
      <Attribute nameComponent={renderAttributeName('New balance (Rand)')}>
        <Typography variant="sh3">{formatCurrencyFull(total, currency)}</Typography>
      </Attribute>
    </Space>
  )
}
